import { render, staticRenderFns } from "./diamond.vue?vue&type=template&id=256ce8bb&scoped=true"
import script from "./diamond.vue?vue&type=script&lang=js"
export * from "./diamond.vue?vue&type=script&lang=js"
import style0 from "./diamond.vue?vue&type=style&index=0&id=256ce8bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ce8bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256ce8bb')) {
      api.createRecord('256ce8bb', component.options)
    } else {
      api.reload('256ce8bb', component.options)
    }
    module.hot.accept("./diamond.vue?vue&type=template&id=256ce8bb&scoped=true", function () {
      api.rerender('256ce8bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/diamond.vue"
export default component.exports